import React from 'react';

const DownloadStartedModal = ({ closeModal }) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-950/80 px-4 backdrop-blur-md">
      <div className="w-full max-w-md rounded-3xl border border-cyan-300/20 bg-slate-950 p-6 text-center shadow-2xl shadow-cyan-950/40">
        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl border border-cyan-300/20 bg-cyan-400/10 text-2xl">
          ⬇️
        </div>

        <h3 className="mt-4 text-xl font-black text-white">
          Download Started
        </h3>

        <p className="mt-2 text-sm leading-6 text-slate-300">
          Your download has started. Downloads are temporary and may expire shortly
          after processing. Processed files should only be used for content you own
          or have permission to use.
        </p>

        <button
          type="button"
          onClick={closeModal}
          className="mt-5 inline-flex w-full items-center justify-center rounded-2xl bg-cyan-300 px-5 py-3 text-sm font-black uppercase tracking-[0.12em] text-slate-950 transition hover:bg-cyan-200"
        >
          OK
        </button>
      </div>
    </div>
  );
};

export default DownloadStartedModal;